import { Form, Input, Button, Flex } from 'antd';
import { iconColor } from '../../theming';
import classesAuth from '../../common/styles/FormStyles.module.scss';
import getInputRules, { inputType } from '../../utils/getInputRules';
import classesProfile from '../../pages/Profile/style.module.scss';
import { useEffect } from 'react';

const EmailVerificationForm = ({ form, loading, onSubmit, t, resetEmail }) => {
    useEffect(() => {
        if (resetEmail) {
            form.setFieldsValue({ email: resetEmail });
        }
    }, [resetEmail, form]);

    return (
        <Form form={form} onFinish={onSubmit} style={{ width: 'clamp(300px, 85vw, 464px)' }} requiredMark={false}>
            <Form.Item
                className={classesAuth['form-item']}
                label={<span className={classesAuth['form-label']}>{t('profile:email')}</span>}
                name="email"
                rules={getInputRules(t, inputType.EMAIL, t('form:errors.required'), t('form:errors.email'))}
                labelCol={{ span: 24 }}
                style={{ marginBottom: '18px' }}
            >
                <Input
                    className={classesAuth['input-login']}
                    placeholder={t('auth:placeholder.enter-email')}
                    readOnly={!!resetEmail}
                    prefix={
                        <i
                            className="fi-rr-envelope"
                            style={{
                                color: iconColor.signin,
                                fontSize: '18px',
                                marginRight: '12px',
                            }}
                        />
                    }
                />
            </Form.Item>

            <Flex justify="start">
                <Button
                    htmlType="submit"
                    type="primary"
                    size="large"
                    className={classesProfile.submitForm}
                    loading={loading}
                    style={{ marginTop: '12px' }}
                >
                    {t('profile:continueButton')}
                </Button>
            </Flex>
        </Form>
    );
};


export default EmailVerificationForm;
